import moment from "moment";
import "moment/dist/locale/ar-dz";
import "moment/dist/locale/zh-cn";
import "moment/dist/locale/zh-hk";
import "moment/dist/locale/fr";

export function toDateString(date) {
  return moment(date).format('YYYY-MM-DD');
}

export function toDateTimeString(date) {
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
}

export function toListItemDateString(date) {
  // return moment(date).format('MMMM Do YYYY, h:mm A');
  return moment(date).format('MM-DD H:mm');
}

export function toListItemDateString1(date) {
  return moment(date).format('MM.DD HH:mm:ss');
}

export function toYearMonth(date) {
  return moment(date).format('YYYY-MM');
}

export function toMonthDay(date) {
  return moment(date).format('MM-DD');
}

export function toDateGroupTitle(date) {
  return moment(date).format('MMMM Do YYYY');
}

export function changeLocale(lang) {
  if (lang === 'cn') {
    moment.locale('zh-cn');
  } else if (lang === 'hk') {
    moment.locale('zh-hk');
  } else if (lang === 'ar') {
    moment.locale('ar-dz');
  } else if (lang === 'fr') {
    moment.locale('fr');
  } else {
    moment.locale('en');
  }
}
